import { Trans } from "@lingui/macro";
import { UiBox, UiTypography } from "@smp/ui";
import { useCallback } from "react";

import { useContextStickers } from "../../../../context";
import classes from "./sort_dropdown.module.css";

export const SortDropdown = () => {
  const {
    actions: { setSortBy },
    state: { sortBy },
  } = useContextStickers();

  const toggleSort = useCallback(() => {
    setSortBy((state) =>
      state === "created_at" ? "-created_at" : "created_at",
    );
  }, [setSortBy]);

  return (
    <>
      <UiBox display="flex" alignItems="center">
        <UiTypography className={classes.title}>
          <Trans>Sort by: </Trans>
        </UiTypography>
        <UiBox onClick={toggleSort} className={classes.button}>
          <UiTypography className={classes.button_text}>
            {
              {
                created_at: <Trans>Old</Trans>,
                "-created_at": <Trans>Recent</Trans>,
              }[sortBy]
            }
          </UiTypography>
        </UiBox>
      </UiBox>
    </>
  );
};
